import {
  getDeviceInfo,
  getDeviceSensorName,
} from 'domains/event/screens/events/utilities/devices'
import { DeviceType } from 'services/event'

export const getEventDevice = (
  deviceType?: DeviceType,
  commandId?: string,
): string | undefined => {
  if (commandId) return 'App'
  if (deviceType) return getDeviceInfo(deviceType)?.type
  return 'Central'
}

export const getEventDescription = (
  code: string,
  name: string,
  deviceType?: DeviceType,
  sensorType?: number,
): string => {
  const sensorName = getDeviceSensorName(deviceType, sensorType)

  return `${code} - ${name}${sensorName ? ' ' + sensorName : ''}`
}
